var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('user-identity-verification',_vm._g({attrs:{"user-id":_vm.userId,"flat":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var loading = ref.loading;
var verification = ref.verification;
return [_vm._t("default",null,null,{ loading: loading, verification: verification })]}}],null,true)},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }